import * as React from "react";

function SvgEmail(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="1em" height="1em" {...props}><path d="M85.6 17.7H14.4C6.5 17.7 0 24.2 0 32.1v35.6c0 7.9 6.5 14.4 14.4 14.4h71.2c7.9 0 14.4-6.5 14.4-14.4V32.1c0-7.9-6.5-14.4-14.4-14.4zm-3.3 6.9L53.4 53.5c-1.9 1.9-4.9 1.9-6.7 0l-29-28.9h64.6zm10.9 43.1c0 4.2-3.4 7.5-7.5 7.5H14.4c-4.2 0-7.5-3.4-7.5-7.5V32.1c0-2.4 1.1-4.5 2.8-5.9l32.1 32.1c2.3 2.3 5.2 3.4 8.2 3.4s5.9-1.1 8.2-3.4l32.1-32.1c1.7 1.4 2.8 3.5 2.8 5.9v35.6z" /></svg>;
}

export default SvgEmail;